module.exports = __webpack_public_path__ + "static/img/answer@2x.fbe61516.png";